import { OktaAuth } from '../authn';

// Export only a single object
export default OktaAuth;
